import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from "clsx";
import { forwardRef, memo } from "react";
import { ColorsProvider } from "../providers/ColorsProvider";
import { useDefaultProps } from "../providers/utils/defaultProps";
import { mergeSx } from "../system";
import { BaseComponent } from "./BaseComponent";
export const svgClasses = {
    root: "MinervaSvg-root",
};
export const Svg = memo(forwardRef((props, ref) => {
    const { size = "md", width, height, color, colorSet, invertColors, className, sx, ...rest } = useDefaultProps({ component: "Svg", props });
    return (_jsx(ColorsProvider, { color: color, colorSet: colorSet, invertColors: !invertColors, children: ({ color }) => {
            const sizing = {
                xxs: 3,
                xs: 4.5,
                sm: 5,
                md: 6,
                lg: 8,
                xl: 12,
            };
            return (_jsx(BaseComponent, { ref: ref, as: "svg", className: clsx([svgClasses.root, className]), sx: mergeSx({
                    color,
                    width: width ?? sizing[size],
                    height: height ?? sizing[size],
                    display: "block",
                    flexShrink: 0,
                    [`&.${svgClasses.root}`]: {
                        boxSizing: "content-box",
                    },
                }, sx), ...rest }));
        } }));
}));
//# sourceMappingURL=Svg.js.map